module.exports = __webpack_public_path__ + "img/disabled_grading_button.c9f5ea8b.png";